import React from 'react';
import { Button, Form, Input } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import AppShell from './components/AppShell';
import Panel from './components/Panel';
import axiosInstance from './utils/axiosInstance';
import { errorDialog } from './utils/dialog';
import { useNavigate } from 'react-router-dom';

const NewUserPage: React.FC = () => {
    const navigate = useNavigate();

    const addUser = async (username: string, phoneNo: string, password: number, withdrawalPassword: string, referralId: number) => {
        try {
            const response = await axiosInstance.post("admin/protected/newUser", {
                username,
                phoneNo,
                password,
                withdrawalPassword,
                referralId
            })
            if (response?.data) {
                navigate('/user');
            } else {
                errorDialog();
            }

        } catch (error: any) {
            console.error('Error fetching data:', error);
            if (error?.response?.status === 401) {
                navigate('/login');  // Redirect to login if unauthorized
            }
        }
    };


    const onFinish = async (values: any) => {
        console.log('Received values of form: ', values);
        addUser(values.username, values.phoneNo, values.password, values.withdrawalPassword, values.referralId);
    };


    return (
        <AppShell
            title="新建"
            subtitle="会员"
            actions={<Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/user')}>返回</Button>}
        >
            <div className="mx-auto max-w-[460px]">
                <Panel>
                    <Form
                        name="newUser"
                        layout="vertical"
                        requiredMark={false}
                        onFinish={onFinish}
                    >
                        <Form.Item
                            name="username"
                            label="用户名"
                            rules={[{ required: true, message: '请输入用户名' }]}
                        >
                            <Input placeholder="用户名" />
                        </Form.Item>
                        <Form.Item
                            name="phoneNo"
                            label="手机号"
                            rules={[{ required: true, message: '请输入手机号' }]}
                        >
                            <Input placeholder="手机号" />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            label="密码"
                            rules={[{ required: true, message: '请输入密码' }]}
                        >
                            <Input placeholder="密码" />
                        </Form.Item>
                        <Form.Item
                            name="withdrawalPassword"
                            label="提款密码"
                            rules={[{ required: true, message: '请输入提款密码' }]}
                        >
                            <Input placeholder="提款密码" />
                        </Form.Item>
                        <Form.Item
                            name="referralId"
                            label="邀请人ID"
                            rules={[{ required: false, message: '请输入邀请人ID' }]}
                        >
                            <Input placeholder="邀请人ID" type='number' />
                        </Form.Item>

                        <Form.Item className="!mb-0 !mt-6">
                            <Button block size="large" type="primary" htmlType="submit">
                                创建
                            </Button>
                        </Form.Item>
                    </Form>
                </Panel>
            </div>
        </AppShell>
    );
}

export default NewUserPage;